import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackbarService } from 'src/app/shared/services/snackBarService.service';
import { NON_INTERCEPTED_ROUTES } from '../const/non-intercepted-routes.const';
import { Utils } from 'src/app/shared/utils/utils';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private _snackbar: SnackbarService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!this.isSuppressed(req, error)) {
          const message = Utils.getUserFacingErrorMessage(error);
          if (message) {
            const type = error.status === 309 ? 'warn' : 'error';
            this._snackbar.open(message, 'Close', type);
          }
        }
        return throwError(() => error);
      })
    );
  }

  private isSuppressed(req: HttpRequest<unknown>, error: HttpErrorResponse): boolean {
    const errorName = (error as any)?.name ?? '';
    const innerErrorName = (error.error as any)?.name ?? '';
    if (
      error.status === 0 ||
      errorName === 'AbortError' ||
      innerErrorName === 'AbortError' ||
      error.message?.toLowerCase().includes('abort') ||
      error.message?.toLowerCase().includes('cancel')
    ) {
      return true;
    }
    return NON_INTERCEPTED_ROUTES.some(
      rule =>
        error.status === rule.status &&
        req.method === rule.method &&
        rule.urlPattern.test(req.url)
    );
  }
}
